
/**
 * @param {Number} value
 * @param {Number} precision
 */
export function round(value, precision) {
	var multiplier = Math.pow(10, precision || 0);
	return Math.round(value * multiplier) / multiplier;
}


// WEBPACK FOOTER //
// ./src/utils.js